import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";

export const levelSetData = (level) => {
  return {
    type: actionType.LEVEL_SET_DATA,
    level: level,
  };
};

export const levelFailData = (error) => {
  return {
    type: actionType.LEVEL_FAIL_DATA,
    error: error,
  };
};

export const levelLoading = () => {
  return {
    type: actionType.LEVEL_LOADING,
  };
};

export const levelGetData = () => {
  return (dispatch) => {
    dispatch(levelLoading());
    axios
      .get(baseUrl + "/levels", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
       
        dispatch(levelSetData(res.data));
      })
      .catch((error) => dispatch(levelFailData(error)));
  };
};

export const deleteLevelFail = (error) => {
  return {
    type: actionType.DELETE_LEVEL_FAIL,
    error: error,
  };
};

export const deleteLevel = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/levels/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(levelGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deleteLevelFail()));
    }
  };
};

export const postLevelDataStart = () => {
  return {
    type: actionType.POST_LEVEL_DATA_START,
  };
};

export const postLevelDataFail = (error) => {
  return {
    type: actionType.POST_LEVEL_DATA_FAIL,
    error: error,
  };
};

export const postLevelDataSuccess = (success) => {
  return {
    type: actionType.POST_LEVEL_DATA_SUCCESS,
    success: success,
  };
};

export const levelPostLoading = () => {
  return {
    type: actionType.LEVEL_POST_LOADING,
  };
};

export const postLevelData = (data, level, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(postLevelDataStart());
    dispatch(levelPostLoading());
    axios
      .post(baseUrl + "/levels", level, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postLevelDataSuccess(res.data));
        dispatch(levelGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Created",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postLevelDataFail(error));
      });
  };
};

export const updateLevelDataStart = () => {
  return {
    type: actionType.UPDATE_LEVEL_DATA_START,
  };
};

export const levelUpdateLoading = () => {
  return {
    type: actionType.LEVEL_UPDATE_LOADING,
  };
};

export const updateLevelDataFail = (error) => {
  return {
    type: actionType.UPDATE_LEVEL_DATA_FAIL,
    error: error,
  };
};

export const updateLevelDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_LEVEL_DATA_SUCCESS,
    success: success,
  };
};

export const updateLevelData = (data, level, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(updateLevelDataStart());
    dispatch(levelUpdateLoading());

    axios
      .put(baseUrl + `/levels/${data.id}`, level, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updateLevelDataSuccess(res.data));
        dispatch(levelGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updateLevelDataFail(error));
      });
  };
};
